import { render, staticRenderFns } from "./Register_teacher.vue?vue&type=template&id=d1c68444&scoped=true"
import script from "./Register_teacher.vue?vue&type=script&lang=js"
export * from "./Register_teacher.vue?vue&type=script&lang=js"
import style0 from "./Register_teacher.vue?vue&type=style&index=0&id=d1c68444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c68444",
  null
  
)

export default component.exports